import { useRef, useState } from "react";
import { MAX_POLL_ATTEMPTS, POLL_INTERVAL_MS } from "../constants";
const useOutstandingChecksPolling = () => {
  const [refetchInterval, setRefetchInterval] = useState(false);
  const attemptsRef = useRef(0);
  const onDataLoaded = (data) => {
    var _a, _b;
    const outstandingChecks = (_b = (_a = data == null ? void 0 : data.meta) == null ? void 0 : _a.outstandingChecks) != null ? _b : 0;
    if (outstandingChecks === 0) {
      attemptsRef.current = 0;
      setRefetchInterval(false);
      return;
    }
    if (attemptsRef.current < MAX_POLL_ATTEMPTS) {
      attemptsRef.current += 1;
      setRefetchInterval(POLL_INTERVAL_MS);
    } else {
      setRefetchInterval(false);
    }
  };
  return { refetchInterval, onDataLoaded };
};
export default useOutstandingChecksPolling;
